import { render, staticRenderFns } from "./GenericTile.vue?vue&type=template&id=6d5f7a18"
import script from "./GenericTile.vue?vue&type=script&lang=js"
export * from "./GenericTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports